export default function GS_Ranges() {
  return (
    <div className="p-4">
      <h1>GS Ranges</h1>
    </div>
  );
}
